import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Redirect, Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import * as Sentry from '@sentry/browser';

import App from './App';
import * as store from './store';

/* Sentry.init( {
  dsn: process.env.REACT_APP_SENTRY_URL,
  environment: process.env.REACT_APP_SENTRY_ENV,
} ); */

const storeMain = store.default();
const render = () => {
  ReactDOM.render(
    <Provider store={storeMain.store}>
      <ConnectedRouter history={store.history}>
        <PersistGate loading={null} persistor={storeMain.persistor}>
          <Switch>
            <Route path="/" component={App} />
            <Redirect from="*" to="/" />
            {/* <Route path="/es" component={App} /> */}
          </Switch>
        </PersistGate>
      </ConnectedRouter>
    </Provider>,
    document.getElementById( 'root' ),
  );
};

render();
